export type OfflineDatabaseState =
  | 'indisponivel'
  | 'fechado'
  | 'inicializando'
  | 'pronto'
  | 'erro';

export interface OfflineDatabaseStatus {
  state: OfflineDatabaseState;
  userId: number;
  databaseName: string;
  error?: string;
}

export type OfflineSyncAction = 'criar' | 'atualizar' | 'excluir' | 'arquivo';
export type OfflineSyncOperationStatus = 'pendente' | 'processando' | 'concluida' | 'erro' | 'conflito';

export interface OfflineSyncOperationInput {
  module: string;
  entityType: string;
  entityUuid: string;
  action: OfflineSyncAction;
  payload: unknown;
  operationUuid?: string;
  dependencyUuid?: string | null;
}

export interface OfflineSyncOperation {
  id: number;
  operationUuid: string;
  module: string;
  entityType: string;
  entityUuid: string;
  action: OfflineSyncAction;
  payload: unknown;
  dependencyUuid: string | null;
  status: OfflineSyncOperationStatus;
  attempts: number;
  availableAt: string;
  lastError: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OfflineSyncQueueSummary {
  pending: number;
  processing: number;
  errors: number;
  conflicts: number;
}

export interface OfflineSyncPullResult {
  cursor: string | null;
  hasMore?: boolean;
}

export interface OfflineSyncModuleHandler {
  readonly module: string;
  push(operation: OfflineSyncOperation): Promise<void>;
  pull?(cursor: string | null): Promise<OfflineSyncPullResult>;
}

export type OfflineSyncState =
  | 'inativo'
  | 'preparando'
  | 'pronto'
  | 'offline'
  | 'sincronizando'
  | 'erro'
  | 'indisponivel';

export interface OfflineSyncStatus {
  state: OfflineSyncState;
  userId: number;
  connected: boolean;
  lastSyncAt: string | null;
  summary: OfflineSyncQueueSummary;
  error?: string;
}

export class OfflineSyncConflictError extends Error {
  constructor(
    message: string,
    readonly serverPayload: unknown = null,
    readonly localPayload: unknown = null,
  ) {
    super(message);
    this.name = 'OfflineSyncConflictError';
  }
}

export function createOfflineUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const randomPart = Math.random().toString(16).slice(2);
  return `${Date.now().toString(16)}-${randomPart}-${Math.random().toString(16).slice(2)}`;
}

